import { render, staticRenderFns } from "./TableCourse.vue?vue&type=template&id=77b734ee&"
import script from "./TableCourse.vue?vue&type=script&lang=js&"
export * from "./TableCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports